const text = `INFORMACIÓN LEGAL DE LA APLICACIÓN SIDE ONCO SKIN®


EDITOR


PIERRE FABRE DERMO-COSMETIQUE, sociedad por acciones simplificada con domicilio social en Les Cauquillous, 81500 Lavaur (Francia), inscrita en el RCS de Castres con el número 319 137 576.

FINANCIACIÓN

PIERRE FABRE DERMO-COSMETIQUE, sociedad por acciones simplificada con domicilio social en Les Cauquillous, 81500 Lavaur (Francia), inscrita en el RCS de Castres con el número 319 137 576.



Director editorial


Sr. Frédéric Ennabli, presidente de Pierre Fabre Dermo-Cosmétique


Administrador del sitio web


contact.avene@pierre-fabre.com


Anfitrión


EMPRESA OVH

SAS con capital de 10 069 020 euros, registrada en 2 rue Kellermann, 59100 Roubaix (Francia),

con el número 537 407 926, y domicilio social en 2 rue Kellermann, 59100 Roubaix (Francia).


Créditos


Edición/Fotos: Profesora Caroline ROBERT, doctora Emmanuelle VIGARIOS, profesor Vincent SIBAUD, profesor Jean-Pierre DELORD.

Diseño/Producción técnica:

Agencia Henri Trip - 756 CHEMIN DE LA CRABO 31870 LAGARDELLE-SUR-LEZE (Francia) - N.º SIRET: 88821442600015



CONDICIONES GENERALES DE USO DE LA APLICACIÓN SIDE ONCO SKIN ®

Las presentes condiciones generales de uso (en adelante, las «CGU») determinan las condiciones de acceso y utilización de la aplicación móvil «ONCO SKIN®», de propiedad exclusiva (en adelante, la «Aplicación»), y que los usuarios (en adelante, los «Usuarios») aceptan por el mero hecho de consultarlas. La Aplicación puede descargarse desde Apple Store y Google Play. Si no las acepta, le rogamos que salga de la Aplicación. Las CGU se rigen por la legislación francesa y pueden modificarse en cualquier momento sin previo aviso. El uso y la consulta de la Aplicación están limitados a fines personales y no comerciales. En general, el Usuario se compromete a no utilizar la totalidad ni parte de la Aplicación para fines ilegales (derechos de autor) o que infrinjan las presentes CGU. Al consultar esta Aplicación, el Usuario se compromete a respetar las CGU expuestas en la fecha de consulta.


ARTÍCULO 1. OBJETO DE LA APLICACIÓN


La Aplicación ha sido creada para apoyar y formar a los profesionales sanitarios (médicos generales y especialistas, farmacéuticos, personal paramédico, médicos residentes) en el trato de los pacientes con síntomas dermatológicos relacionados con los tratamientos contra el cáncer. Esto se consigue mediante lo siguiente:

- La digitalización del libro Dermatologie des traitements anticancéreux de la profesora Caroline ROBERT y el doctor Vincent SIBAUD.

- Cuestionarios y casos prácticos para profesionales sanitarios.

(En lo sucesivo, la «Información»).

La Aplicación no constituye una oferta contractual. La Aplicación es gratuita y no tiene compras integradas.

En particular, la Aplicación difunde Información no contractual sobre patologías dermatológicas, siempre con el afán de mejorar la atención que dispensan los profesionales sanitarios mencionados a los pacientes, pero sin intención de ofrecer directamente la compra de un producto o servicio (salvo que se indique expresamente lo contrario) relacionado con dichas patologías.

Ya que la Aplicación se actualiza teniendo en cuenta todas las actividades, puede ocurrir que determinados datos o anuncios nuevos ya no tengan validez en el momento de su difusión o que simplemente estén desfasados. Pierre Fabre Dermo-Cosmétiques (PFDC) no puede garantizar que toda la Información o las noticias publicadas en la Aplicación estén completamente actualizadas, aunque hará todo lo posible para que así sea.

La Información proporcionada en la Aplicación pretende mejorar, y no sustituir, la relación entre el profesional sanitario y el paciente.


ARTÍCULO 2. POLÍTICA EDITORIAL


El contenido científico de la Aplicación está escrito en parte por médicos expertos en su campo de la dermatología:

•

• El profesor Vincent SIBAUD


El contenido de la Aplicación se actualiza cada tres (3) meses.


ARTÍCULO 3. REQUISITOS TÉCNICOS


PFDC recuerda a los Usuarios que usar la Aplicación presupone que disponen de los conocimientos de hardware y software necesarios para utilizar Internet. Para usar la Aplicación en un teléfono móvil (en adelante, el «Equipo»), el Usuario debe disponer de un acceso a Internet de banda ancha adecuado, una suscripción telefónica que permita el acceso a Internet y un teléfono móvil compatible con la Aplicación, como un smartphone (IOS, Android), conexión WAP, wifi o conexión 3G/4G en su teléfono.


ARTÍCULO 4. CREAR Y ELIMINAR UNA CUENTA DE USUARIO


Para obtener acceso a la Aplicación, es necesario registrarse y crear una cuenta de usuario (en adelante, la «Cuenta de Usuario»). Se invita a los Usuarios a descargar la Aplicación y rellenar el formulario de registro (profesión, datos de contacto, dirección de correo electrónico y contraseña). Cada Usuario está autorizado a ser titular de una (1) sola Cuenta de Usuario. Solo podrá instalar una (1) Aplicación en su Equipo.


El Usuario reconoce que es su responsabilidad respetar el carácter confidencial y personal del nombre de usuario y la contraseña asociados a su cuenta. En consecuencia, se compromete a ser el único responsable ante PFDC de todos los actos realizados mediante su Cuenta de Usuario, así como de la protección de su contraseña. Esta ha de guardarse de forma segura y no debe comunicarse ni compartirse con terceros. En consecuencia, toda conexión o transmisión de datos efectuada utilizando la contraseña de un Usuario se considerará realizada por dicho Usuario. PFDC no se hará responsable de la pérdida de esa contraseña. En caso de pérdida, robo o usurpación de la contraseña o la Cuenta de Usuario, el Usuario se compromete

a informar sin demora a PFDC mediante la dirección indicada al principio de las CGU o por correo electrónico: contact.avene@pierre-fabre.com.


Los Usuarios pueden solicitar la supresión de su Cuenta de Usuario y de cualquier dato que les concierna, en cualquier momento, sin necesidad de justificar su solicitud, enviando un correo electrónico a contact-avene@pierre-fabre.com o por correo postal a la dirección indicada al principio de las CGU.


Los Usuarios también pueden eliminar su Cuenta de Usuario directamente en la aplicación, en la sección «Mi perfil», en cualquier momento, sin tener que justificar su decisión. Se podrá poner fin al uso de la Aplicación por parte de un Usuario con un preaviso de un (1) mes.


PFDC también se reserva el derecho a cancelar la Cuenta de Usuario, de pleno derecho, en caso de resolución judicial que le obligue a ello, por causas de fuerza mayor, por incumplimiento de las presentes CGU o en caso de sospecha de fraude.


PFDC se reserva el derecho a reclamar daños y perjuicios por cualquier pérdida sufrida como consecuencia de tales infracciones.


La rescisión de la Cuenta de Usuario conlleva la rescisión de las licencias concedidas al Usuario, que deberá cesar todo uso de la Aplicación. A este respecto, el Usuario no tendrá derecho a indemnización alguna.

PFDC puede verse obligada a revelar información personal cuando ello sea necesario para la identificación, la detención o el procesamiento de toda persona susceptible de causar daños o perjuicios (ya sea intencionadamente o no) a los derechos o la propiedad de la Aplicación, a otros usuarios de esta o a cualquier otra persona susceptible de ser penalizada por tales actividades.


ARTÍCULO 5. CONDICIONES DE USO DE LA APLICACIÓN


El Usuario reconoce que las condiciones del contrato con su operador de telefonía móvil seguirán aplicándose cuando utilice la Aplicación. El Usuario será el único responsable de todos los cargos que pueda cobrar el operador de telefonía móvil en relación con el acceso a los servicios de conexión a Internet, wifi, WAP o 3G durante el uso de la Aplicación.


Al utilizar la Aplicación, los Usuarios se abstendrán de obstaculizar o interrumpir el correcto funcionamiento de esta, de sus servidores o de redes conectadas a ella, así como de

modificarla, adaptarla o piratearla, o de modificar una aplicación o un sitio de terceros de forma que se induzca a confusión en cuanto a la vinculación con ella.

El Usuario es consciente de las restricciones y limitaciones de las redes móviles de Internet y de telecomunicaciones, por lo que se compromete a lo siguiente:

- Proteger su Equipo contra cualquier forma de virus o intento de intrusión, acceso no autorizado o uso por parte de terceros.

- Supervisar las condiciones de instalación, funcionamiento y mantenimiento de su Equipo necesarias para el correcto funcionamiento de la Aplicación.


ARTÍCULO 6. USO DE LOS CONSEJOS PROPORCIONADOS EN LA APLICACIÓN


En la Aplicación hay disponible Información para los Usuarios, lo que no implica la transferencia de ningún derecho de propiedad vinculado a la Información. A los Usuarios solo se les concede una licencia no exclusiva de consultar y utilizar esta Información para su uso privado. Por lo tanto, se prohíbe a los Usuarios copiar o reproducir total o parcialmente la Información por cualquier medio y en todo soporte existente o futuro, traducirla a cualquier otro idioma o lengua, así como adaptarla.


PFDC no podrá ser considerada responsable de las consecuencias, directas o indirectas, ni de los daños que puedan producirse como consecuencia de una Información errónea o pirateada. Además, PFDC no asume una obligación de resultado sino de medios en relación con la Información y el asesoramiento facilitados a los Usuarios.


Por último, PFDC no ofrece ninguna garantía, explícita o implícita, ni asume responsabilidad alguna en relación con el uso de esta Información o consejos. Estos datos son meramente orientativos. Para más información o consultas, póngase en contacto con contact.avene@pierre-fabre.com.







ARTÍCULO 7. PROPIEDAD INTELECTUAL


Salvo estipulación contraria en el presente documento, todos los elementos que aparecen en la Aplicación y la Aplicación en sí (textos, datos, bases de datos, gráficos, logotipos, marcas,

nombres, animaciones, imágenes, vídeos, sonidos, software y todos los demás elementos; en adelante, los «Elementos») son propiedad exclusiva de PFDC o de terceros que hayan concedido una licencia, y están sujetos a la legislación francesa e internacional sobre derechos de autor y, de forma más general, sobre propiedad intelectual.

Estos Elementos están protegidos por derechos de autor, marcas registradas, patentes, derechos sobre bases de datos, secretos de fabricación o cualquier otro derecho de propiedad intelectual.

Quedan reservados todos los derechos de reproducción, representación y comunicación pública, incluidas las representaciones visuales, fotográficas, iconográficas y de otro tipo. Queda terminantemente prohibida la reproducción total o parcial de la Aplicación en cualquier soporte electrónico sin la autorización expresa del director de la publicación.

Las marcas y logotipos utilizados en la Aplicación han sido registrados y su reproducción constituiría una infracción. Todos los derechos reservados. De conformidad con el artículo L.122-4 del Código francés de Propiedad Intelectual, toda representación o reproducción no autorizada expresamente, total o parcial y por cualquier procedimiento, es ilícita y constituye una falsificación sancionada por los artículos L. 335-2 y siguientes de este código.

PFDC concede al Usuario una licencia personal, gratuita, no exclusiva e intransferible y limitada al uso privado para acceder a la Aplicación y sus Elementos, utilizarlos y visualizarlos. Este derecho se concede exclusivamente para uso personal, privado y no comercial, y a condición de que se conserven todas las referencias a la reproducción y los derechos de propiedad intelectual correspondientes. Así, queda prohibido para el Usuario copiar o reproducir total o parcialmente los Elementos por cualquier medio y en cualquier soporte, existente o futuro, traducirlos a todo otro idioma o lengua, así como adaptarlos.

Cualquier otro uso de los Elementos está estrictamente prohibido y constituye una vulneración de las disposiciones del Código de Propiedad Intelectual francés.



ARTÍCULO 8. ENLACES DE HIPERTEXTO


Se informa al Usuario de que PFDC puede proporcionar enlaces a sitios web o aplicaciones externas pertenecientes o no al Grupo Pierre Fabre. Estos sitios web o aplicaciones son independientes de la Aplicación.

PFDC no edita ni controla las fuentes y el contenido de estos sitios web o aplicaciones ni sus enlaces a otros sitios web o aplicaciones.

Los enlaces a estos sitios web o aplicaciones no constituyen en modo alguno aprobación, validación o respaldo por parte de PFDC de su contenido y, a fortiori, del uso que pueda hacerse de ellos.

En consecuencia, PFDC no se hace responsable de los contenidos, productos, servicios, publicidad, cookies u otros elementos de estos sitios web o aplicaciones, ni de los daños o perjuicios, probados o alegados, derivados o relacionados con el uso de la información, los servicios o los datos disponibles en estos sitios web o aplicaciones.

Los enlaces de hipertexto solo podrán crearse en la Aplicación previa autorización por escrito de PFDC. Todas las solicitudes de autorización deben enviarse a la siguiente dirección de contacto: contact.avene@pierre-fabre.com.




ARTÍCULO 9. GARANTÍAS


PFDC garantiza que el contenido de la Aplicación cumple las disposiciones legales francesas vigentes y las normas del sector sobre las aplicaciones web.

PFDC garantiza el disfrute de la Aplicación por parte de los Usuarios y, en particular, que esta no infringe ningún derecho de propiedad intelectual de terceros y que es original.


PFDC no garantiza la exactitud ni la integridad de la Información contenida en la Aplicación. PFDC efectuará las correcciones correspondientes. Además, la Información difundida puede haber sido actualizada entre el momento en que los Usuarios la vieron y el momento en que tienen conocimiento de ella. Por lo tanto, PFDC no garantiza en modo alguno que esta Información sea exacta, completa y actualizada.


ARTÍCULO 10. RESPONSABILIDAD


El uso de la Aplicación es responsabilidad exclusiva del Usuario. PFDC no será responsable de los resultados obtenidos como consecuencia del uso de la Aplicación. En particular, se ha informado al Usuario de que la Aplicación no pretende reemplazar el asesoramiento médico ni sustituye la relación entre el profesional sanitario y el paciente/Usuario.


El Usuario se compromete a no introducir, ya sea de forma voluntaria o involuntaria, virus, errores o archivos de cualquier tipo que puedan perturbar el funcionamiento de la Aplicación; en caso de hacerlo, será el único responsable. En aras del respeto a todos, PFDC podrá emprender acciones legales contra los Usuarios que vulneren sus condiciones aquí expuestas.


El Usuario declara y garantiza que conoce perfectamente las características y limitaciones de Internet y, en particular, que la transmisión de datos e información en Internet solo es relativamente fiable desde un punto de vista técnico, ya que circula por redes heterogéneas con características y capacidades técnicas diferentes, que pueden interrumpir el acceso o imposibilitarlo en determinados momentos.


PFDC no será responsable de ningún daño derivado de la conexión o el uso de la Aplicación por parte de un Usuario.


PFDC trata de mantener la Aplicación accesible 7 días a la semana y 24 horas al día, pero no tiene la obligación de hacerlo. Por lo tanto, puede interrumpir el acceso, en particular con fines de mantenimiento y mejora. PFDC también se reserva el derecho, en cualquier momento y sin previo aviso, de modificar, suspender o incluso interrumpir la distribución de toda o parte de la Aplicación. PFDC no es en ningún caso responsable de la totalidad de estas interrupciones ni de las consecuencias que puedan tener para el Usuario o cualquier tercero.


A pesar de que PFDC ha adoptado las medidas necesarias para garantizar la fiabilidad de la Información y los servicios contenidos en la Aplicación, no podrá ser considerada responsable de los errores, omisiones, virus o resultados que pudieran derivarse de un uso indebido de la misma. PFDC solo está vinculada por una simple obligación de medios.


Ninguno de los directores o empleados de PFDC podrá ser considerado responsable de lo siguiente:

- Todo daño derivado de la conexión, el acceso o el uso de la Aplicación;

- Los daños resultantes directa o indirectamente de la consulta de la Aplicación o del uso de la Información disponible en ella;

- Los daños directos o indirectos resultantes del uso de la Aplicación y, en particular, toda pérdida operativa, financiera o comercial o de programas o datos en cualquier sistema de información, incluso si se ha informado a PFDC de la posibilidad de tales daños.

En ningún caso PFDC será responsable de pérdidas de la Información ni de daños relacionados con esta. Ninguna información o consejo proporcionado por la Aplicación se interpretará como garantía de ningún tipo.


ARTÍCULO 11. DATOS PERSONALES


El acceso y el uso de la Aplicación implican la recogida de datos personales (apellidos, nombre, dirección de correo electrónico), que el Usuario acepta. Estos datos personales se conservarán durante el tiempo necesario para el uso de la Aplicación. Para saber más sobre el tratamiento de los datos personales y sus derechos, consulte la política de privacidad.


ARTÍCULO 12. LEGISLACIÓN APLICABLE Y RESOLUCIÓN DE LITIGIOS


Las CGU se rigen por la legislación francesa. Cualquier disputa que surja en relación con estas CGU se someterá a mediación, antes de cualquier acción legal o arbitraje. Si fracasa la

mediación, el litigio se someterá al tribunal competente de la jurisdicción del Tribunal de Apelación de París. Si las CGU están traducidas, solo será válida y aplicable la versión francesa.


ARTÍCULO 13. MODIFICACIÓN DE LAS GGU


Los Usuarios declaran y reconocen que han leído las CGU y que el uso de la Aplicación constituye la aceptación plena e incondicional de todas ellas. Las CGC pueden ser modificadas en cualquier momento por PFDC. Se notificará al Usuario de estos cambios. Cualquier uso de la Aplicación, después que se notifique que se ha modificado, constituirá aceptar las CGU. Las CGU aplicables serán entonces las vigentes en la Aplicación en la fecha de su uso por parte de un Usuario. En caso de desacuerdo con las modificaciones de las CGU, el Usuario se compromete a no acceder a la Aplicación y a eliminarla.


Versión 4, 27/08/2024
`

export default text;

